import { defineComponent as _defineComponent } from 'vue'
import QrcodeVue from "qrcode.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose }) {
  expose();

const qrValue = window.location.href;

const __returned__ = { qrValue, QrcodeVue }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})